import { render, staticRenderFns } from "./BaseBasicInfo.vue?vue&type=template&id=45237216&scoped=true&"
import script from "./BaseBasicInfo.vue?vue&type=script&lang=js&"
export * from "./BaseBasicInfo.vue?vue&type=script&lang=js&"
import style0 from "./BaseBasicInfo.vue?vue&type=style&index=0&id=45237216&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45237216",
  null
  
)

export default component.exports